"use client"

import { useSearchParams } from "next/navigation";
import { useContextStore } from "@/src/stores/useContextStore";
import { PROCESS_INSTANCE_QUERY } from "@/src/shared/const";
import { parseContextVariableValue } from "@/src/shared/utils/dataTypeHelpers";
import { isString } from "lodash";
import { updateProcessInstanceField } from "@/src/api/services/processInstance";
import { useDebouncedCallback } from "use-debounce";
import { USE_FIELD_UPDATE_DELAY } from "@/src/shared/const/delay";
import { useEffect } from "react";

export const useFieldDebouncedCallback = (
  fieldName: string,
  delay: number = USE_FIELD_UPDATE_DELAY
) => {
  const searchParams = useSearchParams();
  const getVariable = useContextStore((state) => state.getVariable);
  const processInstanceId = searchParams.get(PROCESS_INSTANCE_QUERY);
  const variable = getVariable(fieldName);
  const variableId = variable?.id;

  const updateFieldCallback = (value: any) => {
    const currentValue = parseContextVariableValue(value);

    if (!isString(currentValue) || !processInstanceId || !variableId) return;

    try {
      updateProcessInstanceField({
        processInstanceId,
        variableId,
        value: currentValue
      });
    } catch (e) {
      console.error(e);
    }
  };

  const debouncedUpdateField = useDebouncedCallback(updateFieldCallback, delay);

  useEffect(
    () => () => {
      debouncedUpdateField.flush();
    },
    [debouncedUpdateField]
  );

  return debouncedUpdateField;
};


export const useUpdateField = () => {
  const searchParams = useSearchParams();
  const getVariable = useContextStore((state) => state.getVariable);
  const processInstanceId = searchParams.get(PROCESS_INSTANCE_QUERY);


  const updateField = async (fieldName:string,value: any): Promise<void> => {
    const variable = getVariable(fieldName);
    const variableId = variable?.id;
    const currentValue = parseContextVariableValue(value);

    if (!isString(currentValue) || !processInstanceId || !variableId) return;

    try {
      await updateProcessInstanceField({
        processInstanceId,
        variableId,
        value: currentValue
      });
    } catch (e) {
      console.error(e);
    }
  };



  return updateField;
};
